import React from "react";
import { Label } from "./ui/label";
import { Input } from "./ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import AddressFields from "./AddressFields";

const LBL = "text-xs font-semibold uppercase tracking-wider text-slate-500";

function F({ label, children }) {
  return <div className="space-y-1.5 min-w-0"><Label className={LBL}>{label}</Label>{children}</div>;
}

export default function ClientForm({ c, set }) {
  return (
    <div className="space-y-4">
      <div className="grid sm:grid-cols-2 gap-4">
        <F label="Nome / Azienda"><Input data-testid="client-form-name" value={c.name || ""} onChange={(e) => set("name", e.target.value)} /></F>
        <F label="Email"><Input data-testid="client-form-email" type="email" value={c.email || ""} onChange={(e) => set("email", e.target.value)} /></F>
        <F label="Telefono / WhatsApp"><Input data-testid="client-form-phone" value={c.phone || ""} onChange={(e) => set("phone", e.target.value)} /></F>
        <F label="P.IVA / CF"><Input data-testid="client-form-vat" value={c.vat || ""} onChange={(e) => set("vat", e.target.value)} /></F>
      </div>
      <AddressFields value={c} onChange={set} testidPrefix="client-form" />
      <F label="Tipo Cliente">
        <Select value={c.type || "business"} onValueChange={(v) => set("type", v)}>
          <SelectTrigger data-testid="client-form-type"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="business">Azienda o professionista sostituto d'imposta (applica la ritenuta)</SelectItem>
            <SelectItem value="business_nosost">Azienda o professionista non sostituto d'imposta (es. forfettario)</SelectItem>
            <SelectItem value="private">Privato / Estero</SelectItem>
          </SelectContent>
        </Select>
      </F>
    </div>
  );
}
